export default __webpack_public_path__ + "static/media/Opposites03_14.d339da56.png";